{
  const Cookie = require('./Cookie');
  module.exports = {
    getUserName() {
      const getUserName = Cookie.get('UserName', 'MISCGCs') || Cookie.get('UserName');
      return getUserName;
    },
    isSignedIn() {
      return Cookie.get('SignedIn') === '1';
    },
    isSoftSignedIn() {
      return (this.getUserName() && !this.isSignedIn());
    },
    isNewSoftSignedIn() {
      return this.isSoftSignedIn();
    },
  };
}



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@component/common/src/util/UserStatus.js